import { settingsHeartRunnerState } from '../state/settingsHeartRunnerState'
import {  INSERT_ALARM_JSON_REQUEST,
    INSERT_ALARM_JSON_SUCCESS,
    INSERT_ALARM_JSON_ERROR ,
    SYNC_USER_REQUEST,
    SYNC_USER_SUCCESS,
    SYNC_USER_ERROR,
    Abort_Mission_Success,
    Abort_Mission_Request,
    SYNC_SETTING_REQUEST,
    SYNC_SETTING_SUCCESS,
    SYNC_LOCATION_REQUEST,
    SYNC_LOCATION_SUCCESS,
    SYNC_USER_TIME_REQUEST,
    FETCH_AUTO_SYNC_USER_TIME_DATA
  } from '../actions/settingsHeartRunnerAction'
 
  var initialStatusCode=''
export function settingsHeartRunnerReducer(state = settingsHeartRunnerState, action) {
    switch (action.type) {
        case INSERT_ALARM_JSON_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode,
                messageLabel: '',
                errorMessage: '',
            })
        case INSERT_ALARM_JSON_SUCCESS:            
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                messageLabel: action.messageLabel,
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage,
                statusCode:action.statusCode,
            })
        case INSERT_ALARM_JSON_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            }) 
            case SYNC_USER_REQUEST:
            return Object.assign({}, state, {
                isLoadingSyncUser: action.isLoading,
                statusCode:initialStatusCode,
                messageLabel : '',
            })
        case SYNC_USER_SUCCESS:
            return Object.assign({}, state, {
                isLoadingSyncUser: action.isLoading,
                messageLabel: action.messageLabel,
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage,
                statusCode:action.statusCode,

            })
        case SYNC_USER_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            }) 
        case Abort_Mission_Success:
            return Object.assign({}, state,{
                statusCode: action.statusCode,
                errorNumber: action.errorCode,
                errorMessage: action.message,
                messageLabel: action.messageLabel,
                isLoadingAbortMission: action.isLoading,
            })
        case Abort_Mission_Request:
            return Object.assign({}, state,{
                statusCode:initialStatusCode,
                isLoadingAbortMission: action.isLoading,
                messageLabel: '',
                errorMessage: '',
            })
        case SYNC_SETTING_REQUEST:
            return Object.assign({}, state, {
                isLoadingSetting: action.isLoading
            })
        case SYNC_SETTING_SUCCESS:
            return Object.assign({}, state, {
                isLoadingSetting: action.isLoading,
                messageLabel: action.messageLabel,
                statusCode:action.statusCode,
                errorNumber: action.errorCode,

            })
        case SYNC_LOCATION_REQUEST:
            return Object.assign({}, state, {
                isLoadingSyncLocation: action.isLoading
            })
        case SYNC_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                isLoadingSyncLocation: action.isLoading,
                messageLabel: action.messageLabel,
                statusCode:action.statusCode,
                errorNumber: action.errorCode,
            })
        case SYNC_USER_TIME_REQUEST:
            return Object.assign({}, state, {
                isLoadingSyncUserTime: action.isLoading,
                statusCode : '',
                messageLabel : ''
            })
        case FETCH_AUTO_SYNC_USER_TIME_DATA:
            return Object.assign({}, state, {
                isLoadingSyncUserTime: action.isLoading,
                messageLabel: action.message,
                autoSyncUserTime : action.value,
                statusCode : action.statusCode
            })
        default:
            return state;
    }
}
